import { render } from "./B2bPageServicio.vue?vue&type=template&id=590d4909&scoped=true&lang=pug"
import script from "./B2bPageServicio.vue?vue&type=script&lang=js"
export * from "./B2bPageServicio.vue?vue&type=script&lang=js"

import "./B2bPageServicio.vue?vue&type=style&index=0&id=590d4909&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-590d4909"]])

export default __exports__